import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config";
import { log } from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getReportsData = async (token, client_id = "") => {
    log("welcome in getReportsData from web")
    if (!token || token === "") {
        alert("No token in getReportsData")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/getReportsDataApi'
        log("url=" + url)
        const params = {
            client_id: client_id
        };
        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getReportsData")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getReportsData")
        log(err)
        error.value = err.message
        return { error: true, message: "Error loading reports data" }
    }
}

const useGetReportsAPI = () => {
    return { error, getReportsData };
}

export default useGetReportsAPI
